export const CONVERSATION_TYPES = Object.freeze({
  DOCTOR: "doctor",
  PATIENT: "patient",
});

export const SEARCH_DEBOUNCE_MS = 500;
export const SEARCH_BLUR_DELAY_MS = 200;
export const TOAST_DURATION_MS = 1500;
export const GENERIC_MESSAGE_ERROR = "Something went wrong in server. Please try again.";

export const ACCEPTED_ATTACHMENT_TYPES = Object.freeze([
  "image/jpeg",
  "image/png",
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
]);

export const ATTACHMENT_ACCEPT_ATTRIBUTE = ACCEPTED_ATTACHMENT_TYPES.join(",");
